import { c as _c } from "react/compiler-runtime";
import { Button, HStack } from '@chakra-ui/react';
import { CommentAttachmentFile } from '@src/components/sco/Comments/CommentAttachments/types';
import React from 'react';
import { LuFile, LuFileText, LuImage } from 'react-icons/lu';
function iconForMime(mimeType?: string | null) {
  if (mimeType?.startsWith('image/')) {
    return <LuImage />;
  }
  if (mimeType?.includes('pdf') || mimeType?.includes('text')) {
    return <LuFileText />;
  }
  return <LuFile />;
}
function truncateTitle(title: string, max = 28) {
  if (title.length <= max) {
    return title;
  }
  return `${title.slice(0, max - 1)}…`;
}
type CommentAttachmentChipsProps = {
  files?: Array<CommentAttachmentFile | null | undefined>;
};
export const CommentAttachmentChips = props => {
  const $ = _c(13);
  let T0;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== props.files) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const files = (props.files || []).filter(_temp);
      if (files.length === 0) {
        t4 = null;
        break bb0;
      }
      T0 = HStack;
      t0 = 1;
      t1 = "0.5em";
      t2 = "wrap";
      t3 = files.map(_temp2);
    }
    $[0] = props.files;
    $[1] = T0;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    T0 = $[1];
    t0 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[7] !== T0 || $[8] !== t0 || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t5 = <T0 gap={t0} paddingTop={t1} wrap={t2}>{t3}</T0>;
    $[7] = T0;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
function _temp(f) {
  return !!f && !f.deletedAt && !!(f.fullUrl || f.storedFileId);
}
function _temp2(file) {
  const title = file.title || file.storageFileName || "Attachment";
  const href = file.fullUrl || "#";
  return <Button key={file.storedFileId || title} asChild={true} borderRadius="0.25em" borderWidth="1px" maxWidth="220px" size="xs" variant="outline"><a href={href} rel="noopener noreferrer" target="_blank" title={title}>{iconForMime(file.mimeType)}<span style={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: "160px"
      }}>{truncateTitle(title)}</span></a></Button>;
}